var tabs = document.querySelectorAll('[data-tab-target]')
var tabContents = document.querySelectorAll('[data-tab-content]')

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      var target = document.querySelector(tab.dataset.tabTarget)
      tabContents.forEach(tabContent => {
        tabContent.classList.remove('active')
      })
      tabs.forEach(tab => {
        tab.classList.remove('active')
      })
      tab.classList.add('active')
      target.classList.add('active')
    })
  })


let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

// If transperent
var transperentElment = document.querySelector(".allow-transparent-header");
var header = document.querySelector(".header-wrapper");
var topbar = document.querySelector(".utility-bar");
if (transperentElment) {
  header.classList.add("allow-transparent-header");
  topbar.classList.add("allow-transparent-header");
}
const icon_swiper = new Swiper(".text-with-icon-blocks", {
  loop: false,
  slidesPerView: 4,
  grabCursor: true,
  autoplay:true,
  speed: 1000,
  pagination: {
    el: ".text-with-icon-blocks .swiper-pagination",
    clickable: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1, spaceBetween: 0 },
    400: { slidesPerView: 1, spaceBetween: 0 },
    575: { slidesPerView: 2, spaceBetween: 10 },
    768: { slidesPerView: 3, spaceBetween: 10 },
    990: { slidesPerView: 4, spaceBetween: 10 },
  },
});

const pro_icon_swiper = new Swiper(".pro-icons-text", {
  loop: true,
  slidesPerView:6,
  grabCursor: true,
  speed: 1000,
  pagination: {
    el: ".pro-icons-text .swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 2, spaceBetween: 10, pagination: { el: ".pro-icons-text .swiper-pagination", clickable: true }  },
    576: { slidesPerView: 3, spaceBetween: 10, pagination: { el: ".pro-icons-text .swiper-pagination", clickable: true } },
    990: { slidesPerView: 4, spaceBetween: 10, pagination: { el: ".pro-icons-text .swiper-pagination", clickable: true } },
    1199: { slidesPerView: 6, spaceBetween: 10 },
  },
});

const image_swiper = new Swiper(".image-with-text__media-slider", {
  loop: true,
  centeredSlides: true,
  speed: 1000,
  // navigation: {
  //   nextEl: ".swiper-button-next",
  //   prevEl: ".swiper-button-prev",
  // },
  pagination: {
    el: ".image-with-text__media-slider .swiper-pagination",
    clickable: true,
  },
   autoplay: 
    {
      delay: 6000,
    },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1, centeredSlides: true},
    390: { slidesPerView: 1, centeredSlides: true},
    768: { slidesPerView: 1, centeredSlides: true},
    992: { slidesPerView: 1, centeredSlides: true},
    1200: { slidesPerView: 1},
  },
}); 

if(window.innerWidth < 992){
  const tab_swiper = new Swiper(".tab_title_cls", {
  loop: false,
  slidesPerView: 'auto',
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 'auto'},
    390: { slidesPerView: 'auto'},
    768: { slidesPerView: 'auto'},
    992: { slidesPerView: 'auto'},
  },
});
}

if(window.innerWidth < 989){
  const img_txt_swiper = new Swiper(".custm_imge_text", {
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".custm_imge_text .swiper-pagination",
    clickable: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  allowTouchMove: true,
  breakpoints: {
    0: { slidesPerView: 1.3, spaceBetween: 20 ,centeredSlides: true },
    989: { slidesPerView: 1.3, spaceBetween: 20,centeredSlides: true},
  },
});
}

const testimonial_swiper = new Swiper(".testimonial-box-wrapper", {
  loop: true,
  centeredSlides: true,
  speed: 1000,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: 
    {
      delay: 2000,
    },
  pagination: {
    el: ".testimonial-box-wrapper .swiper-pagination",
    clickable: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1.2, spaceBetween: 20, centeredSlides: true },
    390: { slidesPerView: 1.2, spaceBetween: 20, centeredSlides: true },
    768: { slidesPerView: 2, spaceBetween: 30, centeredSlides: true },
    992: { slidesPerView: 2.5, spaceBetween: 30 },
    1200: { slidesPerView: 3.5, spaceBetween: 30 },
  },
});


// faq tabs toggal start 

function togal_tabs(item) {
  item.addEventListener("click", () => {
    toggal_all_tabs(item.getAttribute("data-faq_content"));
  });
}
function toggal_all_tabs(tabs_data) {
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach((b) => {
    if (b.getAttribute("data-faq_content") == tabs_data) {
      if (b.classList.contains("is_open")) {
        b.classList.remove("is_open");
      } else {
        b.classList.add("is_open");
      }
    } else {
      b.classList.remove("is_open");
    }
  });
}
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
  tabs_title.forEach(togal_tabs);
}
faq_taggol();
// faq tabs toggal end

// accordions js start
function faq_taggols() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}

(function() {

  const popup_open = document.querySelectorAll('[data-popup-open]') || null;
  if(popup_open){
      popup_open.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = document.querySelector(event.target.hash) || null;
        console.log(main_popup);
          if(!main_popup) return;
                 main_popup.classList.add("open"); 
                 document.body.classList.add("popup_open");
        });
     });
  }  

  const popup_close = document.querySelectorAll('[data-popup-close]') || null;
  if(popup_close){
      popup_close.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = event.target.closest('[data-poup]') || null;
          if(!main_popup) return;
                 main_popup.classList.remove("open"); 
                 document.body.classList.remove("popup_open");
        });
     });
  } 
  
  faq_taggols();


  const chatButton = document.querySelector('#open-chat-button') || null;
  if(chatButton){
        chatButton.addEventListener('click', function() {
            const popupElement = document.querySelector('#ShopifyChat') || null;
              if(popupElement){
               const myButton = popupElement.shadowRoot.querySelector('button.chat-toggle') || null; // Select element in shadowRoot inside the wrapper
                  if(popupElement){
                      myButton.click();
                  }
              }
            });
  }
  
  
  
})();

// accordions js end

//pdp description scroll
document.addEventListener('click', function (event) {
  if (event.target.matches('.load.more')) {
    event.preventDefault();

    const descriptionSection = document.getElementById('description-section');
    if (descriptionSection) {
      descriptionSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
});

//PDP toltip in mobile
document.addEventListener("DOMContentLoaded", () => {
  const tooltips = document.querySelectorAll(".option-info-modal");

  tooltips.forEach((tooltip) => {
    const svgIcon = tooltip.querySelector(".svg-icon");
    const floatContents = tooltip.querySelector(".float-contents");
    const closeBtn = floatContents ? floatContents.querySelector(".close-btn") : null;

    if (svgIcon && floatContents) {
      svgIcon.addEventListener("click", () => {
        floatContents.style.display = "block";
        floatContents.classList.add('active');
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        floatContents.style.display = "none";
        floatContents.classList.remove('active');
      });
    }
  });
});

//PDP Review Scroll
window.addEventListener('DOMContentLoaded', (event) => {
  const reviewBtn = document.querySelector('.review_btn');
  const closeBtn = document.querySelector('.close_btn');
  const popupContainer = document.querySelector('.popup_container');

  if (reviewBtn) {
    reviewBtn.addEventListener('click', function() {
      if (popupContainer) {
        popupContainer.classList.toggle('hidden');
        popupContainer.classList.add('review_open');
      } 
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      if (popupContainer) {
        popupContainer.classList.add('hidden');
        popupContainer.classList.remove('review_open');
      } 
    });
  } 
});

//footer accordian
// accordions js start
function nav_taggol() {
  const accordionss = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    tab_content.style.maxHeight = tab_content.scrollHeight + "px";
  };
  
  const closeAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(tab_content){
      tab_content.style.maxHeight = null;
    }
  };

  accordionss.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    if(intro && tab_content){
        intro.onclick = (e) => {
          if (tab_content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordionss.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });
}
nav_taggol();

// truncate the short decs pdp
  // document.addEventListener("DOMContentLoaded", function () {
  //   const descriptionElement = document.querySelector(".product__description .des_pro");
  //   const fullDescription = descriptionElement.textContent;
  //   const truncatedDescription = fullDescription.split(" ").slice(0, 25).join(" ") ;
  //   descriptionElement.textContent = truncatedDescription;    
  // });




// cust-dev bundle 

const checkboxes = document.querySelectorAll('.product_count input[type="radio"]');
const mainDiv = document.querySelector(".pdp-featured-product .custom_set");
const input = document.querySelector(".dots_box");
const plusButtons = document.querySelectorAll(".bundle_qty .plus-bundle");
const totalQtyDisplay = document.getElementById("total-qty");
var first_added = true;

// Checkbox click event
checkboxes.forEach(checkbox => {   
    checkbox.addEventListener('change', () => {
        checkboxes.forEach(otherCheckbox => otherCheckbox.checked = otherCheckbox === checkbox);
        setTimeout(updateUI, 200);
    });
});

function updateUI() {
    const selected = document.querySelector(".product_count input[type='radio']:checked");
    if (!selected) return;
    const isThreeProduct = selected.classList.contains("qty_radio_3");
    document.querySelector(".total-product-add").textContent = isThreeProduct ? "3" : "6";
    input?.querySelector(".box_6_main")?.classList.toggle("hidden", isThreeProduct);
    input?.querySelector(".box_3_main")?.classList.toggle("hidden", !isThreeProduct);
    mainDiv?.classList.toggle("3_product", isThreeProduct);
    mainDiv?.classList.toggle("6_product", !isThreeProduct);
    plusButtons.forEach(button => button.classList.remove("disabled"));
    updateTotalQty();
    button_css();  

  const totalQty = parseInt(totalQtyDisplay.textContent, 10);
    if (isThreeProduct && totalQty > 3) {
        resetBundleSelection(false);
    }

  const is_three = mainDiv.classList.contains("3_product");
  if(is_three){
    document.querySelector("[discount_price]").innerHTML = "" 
  }
}

function updateTotalQty() {
    const processedVarIds = new Set();
    const totalQty = [...document.querySelectorAll(".bundle_qty .quantity__input")].reduce((total, input) => {
        const varId = input.dataset.varId;
        if (!processedVarIds.has(varId)) {
            processedVarIds.add(varId);
            return total + parseInt(input.value, 10);
        }
        return total;
    }, 0);
    
    [".box_3_wrapper input", ".box_6_wrapper input"].forEach(selector => {
        document.querySelectorAll(selector).forEach((item, index) => {
            item.classList.toggle('dot-added', index < totalQty);
        });
    });
    // console.log("totalQty",totalQty);
    totalQtyDisplay.textContent = totalQty;
    const maxQty = mainDiv.classList.contains("3_product") ? 2 : 5;
    plusButtons.forEach(button => button.classList.toggle("disabled", totalQty > maxQty));  

}

let products = [];
document.querySelectorAll(".bundle_qty .cart-quantity").forEach(i => {
  if (!i) return;
    i.addEventListener("click", e => {
        const b = e.target.closest("[bundle_product]");
        if (!b) return;
        b.classList.add("active");
        const productId = b.dataset.varId;
        const quantityInput = b.querySelector(".quantity__input");
        const currentQty = parseInt(quantityInput.value, 10) || 0;
        products = products.filter(p => p.id !== productId);
        if (currentQty > 0) products.push({ id: productId, quantity: currentQty });
        updateTotalQty();
        priceUpdate(e);
    });
});

function removeButtonHandler() {
    document.querySelectorAll('.bundle_remove').forEach(button => {
        button.addEventListener('click', function (e) {
            const bundleDiv = this.closest('.main_bundle');
            bundleDiv.classList.remove("active");
            bundleDiv.querySelector('.quantity__input').value = 0;
            updateTotalQty();
            priceUpdate(e);
        });
    });
}
removeButtonHandler();

function customAddToCart(product, openDrawer) {
    fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(product)
    })
    .then(response => response.json())
    .then(response => console.log("Response:", response))
    .catch(error => console.error('Error:', error))
    .finally(() => {
        if (openDrawer) resetBundleSelection(true);
    });
}

function resetBundleSelection(silentReset = false) {
  // console.log("silentReset",silentReset);
    document.querySelectorAll(".bundle_qty .quantity__input").forEach(input => {input.value = 0;});
    document.querySelectorAll('.bundle_remove').forEach(b => b.closest('.main_bundle').classList.remove('active'));
    [".box_3_wrapper input", ".box_6_wrapper input"].forEach(selector => {
        document.querySelectorAll(selector).forEach(item => item.classList.remove('dot-added'));
    });
    plusButtons.forEach(button => button.classList.remove("disabled"));
    if (silentReset != false) {
        document.querySelector('cart-drawer')?.refresh(true);
    }
  
  const totalPrice = document.querySelector('[rel_price]').innerHTML = theme.Currency.formatMoney(0, theme.settings.moneyFormat);
   const discount = document.querySelector(".bundle_discount");
   const originalPrice = document.querySelector('[money_price]');
  const mainPrice = parseFloat(originalPrice.getAttribute('money_price'));
   discount.classList.remove("active");
  updatePrice = originalPrice.setAttribute('money_price',0);
  firstQuantityInput();
}


function firstQuantityInput(){
   const firstQuantityInput = document.querySelector('.bundle_qty .plus-bundle');
    if (firstQuantityInput) {
      firstQuantityInput.click();        
    }
}
document.addEventListener("DOMContentLoaded", function () {
   firstQuantityInput();
});



function bundleDiscount(prcieCount,new_price){
  var new_price ;
  if ( totalQtyDisplay.textContent >= 3 ){
        if( totalQtyDisplay.textContent == 6 ){
          var per_new_price = prcieCount * 0.75;
          new_price = theme.Currency.formatMoney(per_new_price, theme.settings.moneyFormat);
          var mins_dis_price = prcieCount - per_new_price ;
          dicount_price = theme.Currency.formatMoney(mins_dis_price, theme.settings.moneyFormat); 
          const set_dis =  document.querySelector("[discount_price]").innerHTML = dicount_price ;
          discount_per.innerHTML = "-" + second_des 
          discount.classList.add("active");
        }else{
          var per_new_price = prcieCount * 0.85;
          new_price = theme.Currency.formatMoney(per_new_price, theme.settings.moneyFormat);
          var mins_dis_price = prcieCount - per_new_price ;
          dicount_price = theme.Currency.formatMoney(mins_dis_price, theme.settings.moneyFormat);   
          const set_dis =  document.querySelector("[discount_price]").innerHTML = dicount_price ;
          discount_per.innerHTML = "-" + first_des           
          discount.classList.add("active");
        }          
      }else{
        discount.classList.remove("active");
      }
}

function priceUpdate(e,action) {
  const tagetElement = e.target;
  const main_div = tagetElement.closest('[bundle_product]');
  const bundleInput = main_div.querySelector('[data-quantity-variant-id]');
  const priceEle = main_div.querySelector('[bundle_price]');
  const priceGet = parseFloat(priceEle.getAttribute('bundle_price'));
  const totalPrice = document.querySelector('[rel_price]');
  const salePrice = document.querySelector('[sale_price]');
  const originalPrice = document.querySelector('[money_price]');
  const mainPrice = parseFloat(originalPrice.getAttribute('money_price'));
 
  const inputBundle = main_div.querySelector('quantity-input input');
  const inputBundleval = parseInt(inputBundle.value);
  var prcieCount,new_price,updatePrice,dicount_price
  const discount = document.querySelector(".bundle_discount");
  const discount_html = document.querySelector("[discount_price]").innerHTML;
  const discount_per = document.querySelector("[discount_per]")
  const first_des = parseInt(discount_per.getAttribute("first_bundle_dis"));
  const second_des = parseInt(discount_per.getAttribute("second_bundle_dis"));  
  var sDis = (100 - second_des)/100;
  var fDis = (100 - first_des)/100;
  
  var ogsDis = second_des/100;
  var ogfDis = first_des/100;
  
  if (tagetElement.classList.contains('plus-bundle')) {
    button_css();
    priceEle.setAttribute("totalqtyprice",0);
     var SetResetPrice = priceEle.setAttribute('regular_price',priceGet);
     const getReset_price = parseFloat(priceEle.getAttribute('regular_price'));
     const resetOGpriceF = Math.floor(((getReset_price * ogfDis) / 100) * 100) * 3;
     const resetOGpriceS = Math.floor(((getReset_price * ogsDis) / 100) * 100) * 6;
     const totalqtyBundle = priceGet * inputBundleval ;
      priceEle.setAttribute("totalqtyprice",totalqtyBundle);
      prcieCount = getReset_price + mainPrice; 
      new_price = theme.Currency.formatMoney(prcieCount, theme.settings.moneyFormat);   

    if ( totalQtyDisplay.textContent >= 3 ){
        if( totalQtyDisplay.textContent == 6 ){          
          var per_new_price = prcieCount * sDis;
          var mins_dis_price = prcieCount - resetOGpriceS;
          // console.log("prcieCount",prcieCount,"resetOGpriceS",resetOGpriceS,"mins_dis_price",mins_dis_price)
          new_price = theme.Currency.formatMoney(mins_dis_price, theme.settings.moneyFormat);
          dicount_price = theme.Currency.formatMoney(resetOGpriceS, theme.settings.moneyFormat); 
          const set_dis =  document.querySelector("[discount_price]").innerHTML = dicount_price ;
          discount_per.innerHTML = "-" + second_des 
          discount.classList.add("active");
        }else{
          if(first_added || discount_html == ""){
            var per_new_price = prcieCount * fDis;           
            var mins_dis_price = prcieCount - resetOGpriceF;
            
            new_price = theme.Currency.formatMoney(mins_dis_price, theme.settings.moneyFormat);
            dicount_price = theme.Currency.formatMoney(resetOGpriceF, theme.settings.moneyFormat); 
            const set_dis =  document.querySelector("[discount_price]").innerHTML = dicount_price ;
            discount_per.innerHTML = "-" + first_des           
            discount.classList.add("active");
            first_added = false;            
          }else{                  
              discount_per.innerHTML = "-" + first_des           
              discount.classList.add("active");        
          }        
        }     
      }else{
        discount.classList.remove("active");
        document.querySelector("[discount_price]").innerHTML = '';
      }
      updatePrice = originalPrice.setAttribute('money_price',prcieCount);
      bundleInput.setAttribute('bundleTotal',bundleInput.value)
  }
  else if(tagetElement.classList.contains('minus-bundle')){
    button_css();    
    priceEle.setAttribute("totalqtyprice",0);    
    var SetResetPrice = priceEle.setAttribute('regular_price',priceGet);
    const getReset_price = parseFloat(priceEle.getAttribute('regular_price'));
    const resetOGpriceF = Math.floor(((getReset_price * ogfDis) / 100) * 100) * 3;
    const resetOGpriceS = Math.floor(((getReset_price * ogsDis) / 100) * 100) * 6;
    // console.log("resetOGpriceF",resetOGpriceF,"getReset_price",getReset_price);
    const totalqtyBundle = priceGet * inputBundleval ;
     priceEle.setAttribute("totalqtyprice",totalqtyBundle);
     prcieCount = mainPrice - priceGet;  
     if(prcieCount > 0){
        new_price = theme.Currency.formatMoney(prcieCount, theme.settings.moneyFormat);
             // bundleDiscount(prcieCount,new_price);
       if ( totalQtyDisplay.textContent >= 3 ){
        if( totalQtyDisplay.textContent == 6 ){
          
          var per_new_price = prcieCount * sDis;
          new_price = theme.Currency.formatMoney(per_new_price, theme.settings.moneyFormat);
          var mins_dis_price = prcieCount - resetOGpriceS ;
          dicount_price = theme.Currency.formatMoney(mins_dis_price, theme.settings.moneyFormat); 
          const set_dis =  document.querySelector("[discount_price]").innerHTML = dicount_price ;
          discount_per.innerHTML = "-" + second_des 
          discount.classList.add("active");
        }else{
          if(first_added || discount_html == ""){   
            var per_new_price = prcieCount * fDis;
            new_price = theme.Currency.formatMoney(per_new_price, theme.settings.moneyFormat);
            console.log("prcieCount - per_new_price",prcieCount , per_new_price)
            var mins_dis_price = prcieCount - resetOGpriceF ;
            dicount_price = theme.Currency.formatMoney(mins_dis_price, theme.settings.moneyFormat);   
            const set_dis =  document.querySelector("[discount_price]").innerHTML = dicount_price ;
            discount_per.innerHTML = "-" + first_des           
            discount.classList.add("active");
          }else{
             discount_per.innerHTML = "-" + first_des           
             discount.classList.add("active");
          }
        }          
      }else{
         document.querySelector("[discount_price]").innerHTML = '';
         discount.classList.remove("active");
      }
        updatePrice = originalPrice.setAttribute('money_price',prcieCount);
        bundleInput.setAttribute('bundleTotal',bundleInput.value)
     }else{
       new_price = theme.Currency.formatMoney(0, theme.settings.moneyFormat);
       // priceEle.setAttribute("totalqtyprice",0);    
       var SetResetPrice = priceEle.setAttribute('regular_price',prcieCount);
       updatePrice = originalPrice.setAttribute('money_price',0);     
     }
  }
  else if(tagetElement.classList.contains('bundle_remove')){
    button_css();    
    const gettotalqtyBundle = parseInt(priceEle.getAttribute("totalqtyprice"));     
     priceEle.setAttribute("totalqtyprice",gettotalqtyBundle);
    var SetResetPrice = priceEle.setAttribute('regular_price',priceGet);
      prcieCount = mainPrice - gettotalqtyBundle;
      new_price = theme.Currency.formatMoney(prcieCount, theme.settings.moneyFormat);
            // bundleDiscount(prcieCount,new_price);
    if ( totalQtyDisplay.textContent >= 3 ){
        if( totalQtyDisplay.textContent == 6 ){
          var per_new_price = prcieCount * sDis;
          new_price = theme.Currency.formatMoney(per_new_price, theme.settings.moneyFormat);
          var mins_dis_price = prcieCount - per_new_price ;
          dicount_price = theme.Currency.formatMoney(mins_dis_price, theme.settings.moneyFormat); 
          const set_dis =  document.querySelector("[discount_price]").innerHTML = dicount_price ;
          discount_per.innerHTML = "-" + second_des 
          discount.classList.add("active");
        }else{
          var per_new_price = prcieCount * fDis;
          new_price = theme.Currency.formatMoney(per_new_price, theme.settings.moneyFormat);
          var mins_dis_price = prcieCount - per_new_price ;
          dicount_price = theme.Currency.formatMoney(mins_dis_price, theme.settings.moneyFormat);   
          const set_dis =  document.querySelector("[discount_price]").innerHTML = dicount_price ;
          discount_per.innerHTML = "-" + first_des           
          discount.classList.add("active");
        }          
      }else{
        discount.classList.remove("active");
        document.querySelector("[discount_price]").innerHTML = '';
      }
      var SetResetPrice = priceEle.setAttribute('totalqtyprice',0);
      updatePrice = originalPrice.setAttribute('money_price',prcieCount);
      // console.log("new_price",new_price);
  }
  
  if (!isNaN(prcieCount)) {
    totalPrice.innerHTML = new_price;
    salePrice.innerHTML = new_price;
  }
}

function button_css(){
  const bundleAtc = document.querySelectorAll(".add-to-cart-bundle button");
  const checkbox_6 =  mainDiv?.classList.contains("6_product");  
  const qty = totalQtyDisplay.textContent;
  bundleAtc?.forEach(button => {
    button.classList.remove("active-green"); 
    if((qty == 3 || qty == 6) && ( !checkbox_6 || qty != 3 )){     
      button.classList.add("active-green");
    }        
  })
}

// Add to cart button
const bundleAtc = document.querySelectorAll(".add-to-cart-bundle");
if(bundleAtc){
  bundleAtc.forEach(button => {
    button.addEventListener("click", () => {
      let itemArr = [];
      document.querySelectorAll('.main_bundle.active').forEach(item => {
          const productVarId = item.dataset.varId;
          const product = products.find(p => p.id === productVarId);
        const customProperties = {'Bundle Item': 'Yes'};
          if (product) itemArr.push({ id: productVarId, quantity: product.quantity , properties: customProperties});
      });
      if (itemArr.length > 0) customAddToCart({ items: itemArr }, true);
    });
  })
}
